import { useAuthStore } from '@/store/pinia/auth'
import { useIdle, useWindowFocus, whenever } from '@vueuse/core'
import { computed, ref } from 'vue'
import { useGetEndpoint } from './getComposable'
import { useV2Api } from '..'

export function useAuthPing() {
  const authStore = useAuthStore()
  const api = useV2Api()

  if (!authStore._token) {
    return
  }

  const { idle } = useIdle()
  const focused = useWindowFocus()

  const query = useGetEndpoint(
    api.auth.ping,
    computed<[] | undefined>(() => []),
  )

  whenever(
    () => !idle.value || focused.value,
    () => {
      query.refresh()
    },
  )
}
